import { Component } from '@angular/core';

@Component({
  selector: 'ngx-store-management-widget',
  templateUrl: './store-management-widget.component.html',
  styleUrls: ['./store-management-widget.component.scss']
})
export class StoreManagementWidgetComponent {
  constructor(){}
}
